type FocusContext = {
	current: HTMLElement | null;
};

/**
 * # cortex:react-ui-std:helper:focusContext
 *
 * Simple storage to mutate the current focused DOM element.
 */
export const focusContext: FocusContext = {
	current: null,
};
